/* eslint-disable */

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { MaterialReactTable } from 'material-react-table';
import {
  Alert,
  Snackbar,
  Modal,
  Button,
  Chip,
} from "@mui/material";
import Papa from 'papaparse';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

// Data
import authorsTableData from "layouts/tables/data/authorsTableData";
import { useEffect, useState } from "react";
import axios from "axios";
import formatDate from "utils/formatDate";

// helper function
const prepareInvitationData = (results = []) => {
  return results
    .map((item) => {
      const invitations = (item.invitations || []).map((invitation) => ({
        ...invitation,
        entry_type: "Individual",
        created_date: formatDate(invitation.created_at),
        email_sent_date: invitation.email_sent_at
          ? formatDate(invitation.email_sent_at)
          : "-",
      }));

      if (item.type === "individual") {
        const invitation = invitations[0];

        if (!invitation) {
          return null;
        }

        return {
          ...invitation,
          group_id: item.group_id,
          invitation_count: item.invitation_count,
          entry_type: "Individual",
        };
      }

      return {
        id: `group-${item.group_id}`,
        group_id: item.group_id,
        invitation_count: item.invitation_count,
        entry_type: "Group",

        suffix: "",
        first_name: `Group (${item.invitation_count})`,
        last_name: "",
        email: "",
        company: "",
        position: "",
        phone_number: "",
        message: "",
        created_date: invitations[0]?.created_date || "",
        email_sent_date: "-",
        subRows: invitations,
      };
    })
    .filter(Boolean);
};

function Tables() {

  const accesstoken = sessionStorage.getItem('accessToken');

  const [toast, setToast] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [listing, setListing] = useState([])
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [count, setCount] = useState(0)
  const [showDetailModal, setShowDetailModal] = useState(false)
  const [selectedMessage, setSelectedMessage] = useState("");
  const [search, setSearch] = useState('');

  const [rowSelection, setRowSelection] = useState({});
  const [sendingEmails, setSendingEmails] = useState(false);

  const [showSendEmailModal, setShowSendEmailModal] = useState(false);
  const [pendingInvitations, setPendingInvitations] = useState([]);

  const [emailResults, setEmailResults] = useState([]);

  const getColor = (value) => {
    if (value == "pending") {
      return "#a7af3571"
    } else if (value == "sent") {
      return "#35af3971"
    } else if (value == "rejected") {
      return "#af353571"
    }
  }

  const columns = [
    {
      id: "serial_number",
      header: "#",
      size: 70,
      enableSorting: false,
      enableEditing: false,

      Cell: ({ row }) => {
        if (row.depth > 0) {
          const letter = String.fromCharCode(97 + row.index);

          return (
            <span
              style={{
                paddingLeft: "12px",
                color: "#667085",
                fontWeight: 500,
              }}
            >
              {letter}
            </span>
          );
        }

        const number =
          pagination.pageIndex * pagination.pageSize +
          row.index +
          1;

        return (
          <span
            style={{
              color: "#344054",
              fontWeight: 600,
            }}
          >
            {number}
          </span>
        );
      },
    },
    {
      header: "Type",
      accessorKey: "entry_type",
      size: 120,
      enableEditing: false,
      Cell: ({ row }) => {
        const isGroup = row.original.entry_type === "Group";

        return (
          <Chip
            label={row.original.entry_type}
            size="small"
            sx={{
              fontWeight: 600,
              fontSize: "12px",
              backgroundColor: isGroup ? "#e8f5e9" : "#f1f3f5",
              color: isGroup ? "#067332" : "#495057",
              borderRadius: "6px",
            }}
          />
        );
      },
    },
    {
      header: "Suffix",
      accessorKey: "suffix",
      size: 120,
      enableEditing: false,
      muiTableBodyCellProps: {
        align: "left",
      },
    },
    {
      header: "Recipient",
      id: "recipient",
      size: 220,
      Cell: ({ row }) => {
        if (row.original.entry_type === "Group") {
          return (
            <div>
              <div
                style={{
                  fontWeight: 700,
                  color: "#067332",
                }}
              >
                Recipient Group
              </div>

              <div
                style={{
                  fontSize: "12px",
                  color: "#667085",
                  marginTop: "2px",
                }}
              >
                {row.original.invitation_count} recipients
              </div>
            </div>
          );
        }

        return (
          <div>
            <div
              style={{
                fontWeight: 600,
                color: "#344054",
              }}
            >
              {row.original.first_name}{" "}
              {row.original.last_name}
            </div>

            <div
              style={{
                fontSize: "12px",
                color: "#667085",
                marginTop: "2px",
              }}
            >
              {row.original.email}
            </div>
          </div>
        );
      },
    },
    {
      header: "Company",
      accessorKey: "company",
      enableEditing: false,
      size: 200
    },
    {
      header: "Position",
      accessorKey: "position",
      enableEditing: false,
      size: 200
    },
    {
      header: "Phone",
      accessorKey: "phone_number",
      enableEditing: false,
      size: 200
    },
    {
      header: "Invitation Sent",
      accessorKey: "email_sent_at",
      enableEditing: false,
      size: 200,
      muiTableBodyCellProps: {
        align: "center",
      },
      Cell: ({ row }) => {
        if (!row.original.email_sent_at) {
          return <span style={{ color: "#999", textAlign: "center" }}>—</span>;
        }
        return (
          <span>{formatDate(row.original.email_sent_at)}</span>
        );
      },
    },
    {
      header: "Email Status",
      accessorKey: "email_status",
      size: 160,
      muiTableBodyCellProps: {
        align: "center",
      },
      enableEditing: false,
      Cell: ({ row }) => {
        if (row.original.entry_type === "Group") {
          return <span style={{ color: "#999", textAlign: "center" }}>—</span>;
        }

        const status = row.original.email_status;

        const statusStyles = {
          sent: {
            backgroundColor: "#e8f5e9",
            color: "#067332",
          },
          pending: {
            backgroundColor: "#fff8e1",
            color: "#a66b00",
          },
          failed: {
            backgroundColor: "#fdeaea",
            color: "#b42318",
          },
        };

        return (
          <Chip
            label={status || "Pending"}
            size="small"
            sx={{
              fontWeight: 600,
              fontSize: "12px",
              textTransform: "capitalize",
              borderRadius: "6px",
              ...(statusStyles[status] || statusStyles.pending),
            }}
          />
        );
      },
    },
    {
      header: "Created At",
      accessorKey: "created_at",
      enableEditing: false,
      size: 160,
      muiTableBodyCellProps: {
        align: "center",
      },
      Cell: ({ row }) => {
        if (!row.original.created_at) {
          return <span style={{ color: "#999", textAlign: "center" }}>—</span>;
        }
        return (
          <span>{formatDate(row.original.created_at)}</span>
        );
      },
    },
    {
      header: "Message",
      enableEditing: false,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      size: 200,
      Cell: ({ row }) => {
        if (row.original.entry_type === "Group") {
          return <span>-</span>;
        }

        return (
          <div className="d-flex align-items-center justify-content-center">
            <Button
              size="small"
              variant="text"
              onClick={() => {
                setSelectedMessage(row.original.message);
                setShowDetailModal(true);
              }}
              sx={{
                color: "#067332",
                textTransform: "none",
                fontWeight: 600,
                minWidth: "auto",
                px: 1.5,
                borderRadius: "6px",
                "&:hover": {
                  backgroundColor: "#edf7f1",
                },
              }}
            >
              View
            </Button>
          </div>
        );
      },
    },
  ];

  const showToast = (message, severity = "success") => {
    setToast({
      open: true,
      message,
      severity,
    });
  };

  const handleCloseToast = () => {
    setToast((prev) => ({
      ...prev,
      open: false,
    }));
  };


  // selected invitations to show in modal
  const getSelectedInvitations = (selection = {}) => {
    const invitationRows = listing.flatMap((item) => {
      if (
        item.entry_type === "Group" &&
        Array.isArray(item.subRows)
      ) {
        return item.subRows;
      }

      return [item];
    });

    return invitationRows.filter(
      (invitation) => selection[String(invitation.id)]
    );
  };

  const exportCSV1 = () => {
    const csvData = listing.map(row => ({
      Suffix: row.suffix,
      "First Name": row.last_name,
      "Last Name": row.last_name,
      Email: row.email,
      Company: row.company,
      Position: row.position,
      Phone: row.country_code + row.phone_number,
      Message: row.message,
      "Invitations Date": formatDate(row.created_at),
    }));

    const csv = Papa.unparse(csvData);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "invitations.csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const exportCSV = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/invitations/download`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to download CSV');
      }

      // Parse the response as a Blob
      const responseData = await response.json();

      // Convert the data to CSV format
      const csvData = responseData.map(row => ({
        Suffix: row.suffix,
        "First Name": row.first_name,
        "Last Name": row.last_name,
        Email: row.email,
        Company: row.company,
        Position: row.position,
        Phone: row.country_code + row.phone_number,
        Message: row.message,
        "Invitations Date": formatDate(row.created_at),
      }));

      // Custom CSV headers
      const headers = ['Suffix', 'First Name', 'Last Name', 'Email', 'Company', 'Position', 'Phone', 'Message', 'Invitations Date'];

      // Add headers to the CSV file
      const csv = Papa.unparse({
        fields: headers,
        data: csvData
      });

      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute('download', 'invitations.csv');
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } catch (error) {
      console.error('Error exporting CSV:', error);
    }
  };


  const getInvitationListing = async () => {
    const url = `${process.env.REACT_APP_API_BASE_URL}/invitations/group-list?page=${pagination.pageIndex + 1}&size=${pagination.pageSize ?? 10}&search=${search ? search : ""}`;
    try {
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${accesstoken}` },
      });

      if (response.status === 200) {
        const updatedData = prepareInvitationData(
          response?.data?.results || []
        );

        setListing(updatedData);
        setCount(response?.data?.count)
        // console.log('response:', response);
      }
    } catch (error) {
      console.error('Error during login:', error.response ? error.response.data : error.message);
    }
  };

  const getSelectedInvitationIds = (selection = {}) => {
    return Object.entries(selection)
      .filter(
        ([rowId, isSelected]) =>
          isSelected && !rowId.startsWith("group-")
      )
      .map(([rowId]) => Number(rowId))
      .filter((id) => !Number.isNaN(id));
  };

  const handleRowSelectionChange = (updater) => {
    setRowSelection((previousSelection) => {
      const nextSelection =
        typeof updater === "function"
          ? updater(previousSelection)
          : updater;

      const normalizedSelection = {
        ...nextSelection,
      };

      listing.forEach((item) => {
        if (
          item.entry_type !== "Group" ||
          !Array.isArray(item.subRows) ||
          !item.subRows.length
        ) {
          return;
        }

        const parentId = String(item.id);

        const childIds = item.subRows.map((child) =>
          String(child.id)
        );

        const selectedChildIds = childIds.filter(
          (childId) => nextSelection[childId]
        );

        if (selectedChildIds.length === childIds.length) {
          normalizedSelection[parentId] = true;
        } else {
          delete normalizedSelection[parentId];
        }
      });

      return normalizedSelection;
    });
  };

  const sendEmailsApi = async (invitationIds) => {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/invitations/send-email`,
      {
        ids: invitationIds.join(","),
      },
      {
        headers: {
          Authorization: `Bearer ${accesstoken}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  };

  const handleSendEmails = () => {
    const selectedInvitations =
      getSelectedInvitations(rowSelection);

    if (!selectedInvitations.length) {
      return;
    }

    setEmailResults([]);
    setPendingInvitations(selectedInvitations);
    setShowSendEmailModal(true);
  };

  const handleConfirmSendEmails = async () => {
    if (!pendingInvitations.length) {
      return;
    }

    const invitationIds = pendingInvitations.map(
      (invitation) => invitation.id
    );

    try {
      setSendingEmails(true);

      const response = await sendEmailsApi(invitationIds);

      if (response.status) {
        setEmailResults(response.results || []);
        setRowSelection({});

        getInvitationListing();
      }
    } catch (error) {
      console.error(
        "Error sending emails:",
        error.response?.data || error.message
      );

      showToast(
        "Unable to process the email request. Please try again.",
        "error"
      );
    } finally {
      setSendingEmails(false);
    }
  };

  useEffect(() => {
    if (search != "" && search) {
      setPagination((prev) => ({ ...prev, pageIndex: 0 }));
    }
    if (pagination.pageIndex == 0) {
      getInvitationListing();
    }
  }, [search]);

  useEffect(() => {
    getInvitationListing();
  }, [pagination.pageIndex, pagination.pageSize]);


  const sentCount = emailResults.filter(
    (result) => result.status === "sent"
  ).length;

  const failedCount = emailResults.filter(
    (result) => result.status === "failed"
  ).length;

  const hasEmailResults = emailResults.length > 0;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox px={1} pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card
              sx={{
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.06)",
                border: "1px solid #edf0ee",
              }}
            >
              <MDBox
                mx={2}
                py={1}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Invitation Listing
                </MDTypography>
              </MDBox>
              <MaterialReactTable
                data={listing}
                columns={columns}
                rowCount={count}
                state={{
                  pagination,
                  globalFilter: search,
                  rowSelection,
                }}

                enableExpanding
                getSubRows={(row) => row.subRows}

                enableRowSelection
                enableMultiRowSelection
                enableSubRowSelection
                onRowSelectionChange={handleRowSelectionChange}

                manualPagination
                pagination={pagination}
                onPaginationChange={setPagination}

                manualFiltering
                onGlobalFilterChange={setSearch}

                layoutMode="grid-no-grow"

                enableEditing={false}
                editingMode="table"
                enableColumnFilters={false}
                enableColumnActions={false}
                enableDensityToggle={false}
                enableFilterMatchHighlighting={false}
                enableFullScreenToggle={false}
                enableHiding={false}

                getRowId={(originalRow) => String(originalRow.id)}

                // Main table card
                muiTablePaperProps={{
                  elevation: 0,
                  sx: {
                    borderRadius: "16px",
                    overflow: "hidden",
                    border: "1px solid #e1e8e4",
                    backgroundColor: "#ffffff",
                    boxShadow:
                      "0 8px 30px rgba(16, 24, 40, 0.07)",
                  },
                }}

                // Top toolbar
                muiTopToolbarProps={{
                  sx: {
                    minHeight: "64px",
                    px: 2,
                    py: 1.25,
                    backgroundColor: "#ffffff",
                    borderBottom: "1px solid #edf1ef",

                    "& .MuiBox-root": {
                      alignItems: "center",
                    },
                  },
                }}

                // Bottom toolbar / pagination area
                muiBottomToolbarProps={{
                  sx: {
                    minHeight: "58px",
                    px: 2,
                    backgroundColor: "#fbfcfb",
                    borderTop: "1px solid #edf1ef",
                    boxShadow: "none",
                  },
                }}

                // Table container
                muiTableContainerProps={{
                  sx: {
                    backgroundColor: "#fff",
                  },
                }}

                // Header cells
                muiTableHeadCellProps={{
                  sx: {
                    background:
                      "linear-gradient(180deg, #f4f8f5 0%, #edf4ef 100%)",

                    color: "#3b4b42",
                    fontWeight: 700,
                    fontSize: "11px",
                    textTransform: "uppercase",
                    letterSpacing: "0.07em",

                    borderTop: "1px solid #e1e8e4",
                    borderBottom: "1px solid #d7e3db",

                    paddingTop: "14px",
                    paddingBottom: "14px",

                    "& .MuiTableSortLabel-root": {
                      color: "#3b4b42",

                      "&:hover": {
                        color: "#067332",
                      },

                      "&.Mui-active": {
                        color: "#067332",
                      },

                      "&.Mui-active .MuiTableSortLabel-icon": {
                        color: "#067332",
                      },
                    },
                  },
                }}

                // Body cells
                muiTableBodyCellProps={{
                  sx: {
                    fontSize: "13px",
                    fontWeight: 400,
                    color: "#475467",

                    paddingTop: "12px",
                    paddingBottom: "12px",

                    borderBottom: "1px solid #edf1ef",
                  },
                }}

                // Rows
                muiTableBodyRowProps={({ row }) => {
                  const isGroup = row.depth === 0;
                  const isSubRow = row.depth > 0;

                  return {
                    sx: {
                      transition:
                        "background-color 0.15s ease, box-shadow 0.15s ease",

                      ...(isGroup && {
                        "& td": {
                          background:
                            "linear-gradient(90deg, #e7f4eb 0%, #f1f8f3 100%)",

                          color: "#245c39",
                          fontWeight: 600,

                          borderTop: "1px solid #cfe3d5",
                          borderBottom: "1px solid #cfe3d5",
                        },

                        "& td:first-of-type": {
                          borderLeft: "4px solid #067332",
                        },

                        "&:not(:first-of-type) td": {
                          borderTop: "10px solid #ffffff",
                        },

                        "&:hover td": {
                          background:
                            "linear-gradient(90deg, #dcefe2 0%, #ebf6ee 100%)",
                        },
                      }),

                      ...(isSubRow && {
                        "& td": {
                          backgroundColor: "#ffffff",
                          color: "#475467",
                          borderBottom: "1px solid #edf1ef",
                        },

                        "& td:first-of-type": {
                          borderLeft: "4px solid #dcebe1",
                        },

                        "&:hover td": {
                          backgroundColor: "#f7faf8",
                        },
                      }),
                    },
                  };
                }}

                // Checkbox styling
                muiSelectCheckboxProps={{
                  sx: {
                    "& .MuiSvgIcon-root": {
                      border: "1px solid #067332",
                      borderRadius: "0.35rem",
                    },

                    "&.Mui-checked .MuiSvgIcon-root": {
                      color: "#067332",
                      borderColor: "#067332",
                    },

                    "&.MuiCheckbox-indeterminate .MuiSvgIcon-root": {
                      color: "#067332",
                      borderColor: "#067332",
                    },

                  },
                }}

                // Pagination styling
                muiPaginationProps={{
                  rowsPerPageOptions: [10, 25, 50, 100],
                  sx: {
                    "& .MuiTablePagination-select": {
                      borderRadius: "6px",
                    },

                    "& .MuiIconButton-root": {
                      borderRadius: "8px",

                      "&:hover": {
                        backgroundColor: "#edf7f1",
                        color: "#067332",
                      },
                    },
                  },
                }}

                renderTopToolbarCustomActions={() => {
                  const selectedInvitationIds =
                    getSelectedInvitationIds(rowSelection);

                  return (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        flexWrap: "wrap",
                      }}
                    >
                      <Button
                        variant="outlined"
                        onClick={exportCSV}
                        sx={{
                          height: "38px",
                          textTransform: "none",
                          borderColor: "#d0d5dd",
                          color: "#344054",
                          backgroundColor: "#fff",
                          fontSize: "13px",
                          fontWeight: 600,
                          borderRadius: "8px",
                          px: 2,
                          boxShadow: "0 1px 2px rgba(16, 24, 40, 0.04)",

                          "&:hover": {
                            borderColor: "#067332",
                            color: "#067332",
                            backgroundColor: "#f6fbf8",
                            boxShadow: "none",
                          },
                        }}
                      >
                        Export CSV
                      </Button>

                      <Button
                        variant="contained"
                        onClick={handleSendEmails}
                        disabled={
                          !selectedInvitationIds.length ||
                          sendingEmails
                        }
                        sx={{
                          height: "38px",
                          textTransform: "none",
                          backgroundColor: "#067332",
                          color: "#fff",
                          fontSize: "13px",
                          fontWeight: 600,
                          borderRadius: "8px",
                          px: 2.25,

                          boxShadow:
                            "0 2px 6px rgba(6, 115, 50, 0.22)",

                          transition: "all 0.2s ease",

                          "&:hover": {
                            backgroundColor: "#055f2b",
                            boxShadow:
                              "0 4px 10px rgba(6, 115, 50, 0.25)",
                            transform: "translateY(-1px)",
                          },

                          "&.Mui-disabled": {
                            backgroundColor: "#e4e7ec",
                            color: "#98a2b3",
                            boxShadow: "none",
                          },
                        }}
                      >
                        {sendingEmails
                          ? "Sending..."
                          : selectedInvitationIds.length
                            ? `Send Emails (${selectedInvitationIds.length})`
                            : "Send Emails"}
                      </Button>
                    </div>
                  );
                }}
              />
              <style>
                {`
                  .custom-head-class {
                    padding: 0;
                  }
                `}
              </style>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Modal
        open={showDetailModal}
        onClose={() => setShowDetailModal(false)}
        aria-labelledby="message-modal-title"
        aria-describedby="message-modal-description"
      >
        <div style={{ padding: '20px', backgroundColor: '#fff', margin: '10% auto', width: '400px', borderRadius: '8px' }}>
          <h2 id="message-modal-title">Message Details</h2>
          <p id="message-modal-description">{selectedMessage}</p>
          <Button onClick={() => setShowDetailModal(false)} style={{ backgroundColor: '#067332', color: '#fff', marginTop: '20px' }}>Close</Button>
        </div>
      </Modal>

      {/* confirmation modal */}
      <Modal
        open={showSendEmailModal}
        onClose={() => {
          if (!sendingEmails) {
            setShowSendEmailModal(false);
            setPendingInvitations([]);
          }
        }}
        aria-labelledby="send-email-modal-title"
        aria-describedby="send-email-modal-description"
      >
        <div
          style={{
            padding: "24px",
            backgroundColor: "#fff",
            margin: "8% auto",
            width: "700px",
            maxWidth: "90%",
            borderRadius: "10px",
            boxShadow: "0 10px 30px rgba(0, 0, 0, 0.15)",
          }}
        >
          <h3
            id="send-email-modal-title"
            style={{
              marginTop: 0,
              marginBottom: "8px",
              color: "#344054",
            }}
          >
            {hasEmailResults
              ? "Email Sending Results"
              : "Confirm Send Emails"}
          </h3>

          {hasEmailResults ? (
            <div
              style={{
                display: "flex",
                gap: "16px",
                marginBottom: "20px",
                fontSize: "14px",
              }}
            >
              <span style={{ color: "#067332", fontWeight: 600 }}>
                {sentCount} Sent
              </span>

              <span style={{ color: "#b42318", fontWeight: 600 }}>
                {failedCount} Failed
              </span>

              <span style={{ color: "#667085" }}>
                {emailResults.length} Total
              </span>
            </div>
          ) : (
            <p
              id="send-email-modal-description"
              style={{
                color: "#667085",
                marginTop: 0,
                marginBottom: "20px",
                fontSize: "16px",
              }}
            >
              You are about to send an email to{" "}
              <strong>{pendingInvitations.length}</strong>{" "}
              {pendingInvitations.length === 1
                ? "recipient"
                : "recipients"}
              . Please review the recipients before sending.
            </p>
          )}

          <div
            style={{
              maxHeight: "320px",
              overflowY: "auto",
              border: "1px solid #e4e7ec",
              borderRadius: "8px",
            }}
          >
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "13px",
              }}
            >
              <thead>
                <tr
                  style={{
                    backgroundColor: "#f7f9f8",
                    textAlign: "left",
                  }}
                >
                  <th
                    style={{
                      padding: "12px",
                      color: "#667085",
                    }}
                  >
                    Name
                  </th>

                  <th
                    style={{
                      padding: "12px",
                      color: "#667085",
                    }}
                  >
                    Company
                  </th>

                  <th
                    style={{
                      padding: "12px",
                      color: "#667085",
                    }}
                  >
                    Position
                  </th>

                  <th
                    style={{
                      padding: "12px",
                      color: "#667085",
                    }}
                  >
                    Status
                  </th>
                </tr>
              </thead>

              <tbody>
                {pendingInvitations.map((invitation) => {
                  const result = emailResults.find(
                    (item) => Number(item.id) === Number(invitation.id)
                  );

                  const status = result
                    ? result.status
                    : invitation.email_status || "pending";

                  return (
                    <tr
                      key={invitation.id}
                      style={{
                        borderTop: "1px solid #e4e7ec",
                      }}
                    >
                      <td
                        style={{
                          padding: "12px",
                          color: "#344054",
                        }}
                      >
                        <div
                          style={{
                            fontWeight: 600,
                          }}
                        >
                          {[
                            invitation.first_name,
                            invitation.last_name,
                          ]
                            .filter(Boolean)
                            .join(" ") || "-"}
                        </div>

                        <div
                          style={{
                            fontSize: "11px",
                            color: "#667085",
                            marginTop: "3px",
                          }}
                        >
                          {invitation.email || "-"}
                        </div>
                      </td>

                      <td
                        style={{
                          padding: "12px",
                          color: "#475467",
                        }}
                      >
                        {invitation.company || "-"}
                      </td>

                      <td
                        style={{
                          padding: "12px",
                          color: "#475467",
                        }}
                      >
                        {invitation.position || "-"}
                      </td>

                      <td style={{ padding: "12px" }}>
                        <Chip
                          label={status}
                          size="small"
                          sx={{
                            fontWeight: 600,
                            fontSize: "11px",
                            textTransform: "capitalize",
                            backgroundColor:
                              status === "sent"
                                ? "#e8f5e9"
                                : status === "failed"
                                  ? "#fdeaea"
                                  : "#fff8e1",
                            color:
                              status === "sent"
                                ? "#067332"
                                : status === "failed"
                                  ? "#b42318"
                                  : "#a66b00",
                          }}
                        />

                        {result?.error && (
                          <div
                            style={{
                              color: "#b42318",
                              fontSize: "11px",
                              marginTop: "5px",
                              maxWidth: "250px",
                              wordBreak: "break-word",
                            }}
                          >
                            {result.error}
                          </div>
                        )}
                      </td>
                    </tr>
                  )
                }
                )}
              </tbody>
            </table>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "10px",
              marginTop: "24px",
            }}
          >
            <span
              style={{
                color: "#667085",
                fontSize: "13px",
              }}
            >
              {pendingInvitations.length}{" "}
              {pendingInvitations.length === 1
                ? "recipient"
                : "recipients"}{" "}
              selected
            </span>

            <div
              style={{
                display: "flex",
                gap: "10px",
              }}
            >
              {hasEmailResults ? (
                <Button
                  variant="contained"
                  onClick={() => {
                    setShowSendEmailModal(false);
                    setPendingInvitations([]);
                    setEmailResults([]);
                  }}
                  sx={{
                    textTransform: "none",
                    backgroundColor: "#067332",
                    color: "#fff",
                    fontWeight: 600,
                    boxShadow: "none",
                    "&:hover": {
                      backgroundColor: "#045b28",
                      boxShadow: "none",
                    },
                  }}
                >
                  Close
                </Button>
              ) : (
                <>
                  <Button
                    variant="outlined"
                    disabled={sendingEmails}
                    onClick={() => {
                      setShowSendEmailModal(false);
                      setPendingInvitations([]);
                      setEmailResults([]);
                    }}
                    sx={{
                      textTransform: "none",
                      borderColor: "#d0d5dd",
                      color: "#344054",
                      fontWeight: 600,
                    }}
                  >
                    Cancel
                  </Button>

                  <Button
                    variant="contained"
                    disabled={
                      sendingEmails ||
                      !pendingInvitations.length
                    }
                    onClick={handleConfirmSendEmails}
                    sx={{
                      textTransform: "none",
                      backgroundColor: "#067332",
                      color: "#fff",
                      fontWeight: 600,
                      boxShadow: "none",
                      "&:hover": {
                        backgroundColor: "#045b28",
                        boxShadow: "none",
                      },
                    }}
                  >
                    {sendingEmails
                      ? "Sending..."
                      : `Send (${pendingInvitations.length})`}
                  </Button>
                </>
              )}
            </div>
          </div>
        </div>
      </Modal>

      <Snackbar
        open={toast.open}
        autoHideDuration={4000}
        onClose={handleCloseToast}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Alert
          onClose={handleCloseToast}
          severity={toast.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {toast.message}
        </Alert>
      </Snackbar>
    </DashboardLayout>
  );
}

export default Tables;
